export default {"src":"/_next/static/media/done.9de5ec95.svg","height":88,"width":88,"blurWidth":0,"blurHeight":0};